/**
 * Root component of `apps/web` (Melodimals).
 *
 * Integrates TanStack Router as the navigation layer inside the
 * app's providers.
 */

import { type Component, Suspense } from "solid-js";
import { RouterProvider } from "@tanstack/solid-router";

import { AppProviders } from "@/providers/app-providers";
import { router } from "@/router";

export const App: Component = () => (
  <AppProviders>
    <Suspense fallback={null}>
      <RouterProvider router={router} />
    </Suspense>
  </AppProviders>
);
